import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=792838eb&scoped=true&"
import script from "./ShopList.vue?vue&type=script&lang=ts&"
export * from "./ShopList.vue?vue&type=script&lang=ts&"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=792838eb&lang=scss&scoped=true&"
import style1 from "./ShopList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792838eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCard,VRow,VSkeletonLoader,VTextField})
